import { Link } from "react-router-dom";
import heroImage from "../../assets/commercial-property-hero.jpg";

function Commercial() {
  return (
    <>
      {/* ================= HERO ================= */}
      <section className="relative h-[80vh] flex items-center justify-center pt-24">

        {/* BACKGROUND IMAGE */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${heroImage})`,
          }}
        ></div>

        {/* OVERLAY */}
        <div className="absolute inset-0 bg-black/60"></div>

        {/* CONTENT */}
        <div className="relative z-10 text-center text-white px-6 max-w-3xl">
          <h1 className="text-4xl md:text-6xl font-dancing-script">
           Corporate & Commercial  Law
          </h1>

          <p className="mt-4 text-lg text-gray-200">
            
          </p>
        </div>

      </section>

      {/* ================= CONTENT ================= */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">

          <section className="py-24 bg-white">

  {/* SECTION HEADER */}
  <div className="text-center max-w-4xl mx-auto mb-20 px-6">

    <p className="text-[#0B3D91] uppercase tracking-[6px] font-semibold mb-4">
      Corporate & Commercial Law
    </p>

    <h2 className="text-4xl md:text-5xl font-bold text-[#0B1C39] leading-tight mb-6">
      From Startup <span className="text-[#0B3D91]">&</span> Enterprise
    </h2>

    <p className="text-gray-600 text-lg leading-relaxed">
      <strong>GATI & CO. ADVOCATES</strong> provides strategic legal support
      to businesses at every stage of growth — from incorporation and
      structuring to governance, transactions, compliance, and dispute prevention.
      We help entrepreneurs, startups, partnerships, and established enterprises
      operate with legal clarity, commercial confidence, and long-term stability.
    </p>

  </div>

  {/* MAIN LAYOUT */}
  <div className="max-w-7xl mx-auto px-6 md:px-16 grid lg:grid-cols-12 gap-8">

    {/* LEFT FEATURE PANEL */}
    <div className="lg:col-span-5 relative rounded-[32px] overflow-hidden bg-[#0B1C39] p-10 md:p-14 text-white">

      {/* DECOR */}
      <div className="absolute top-0 right-0 w-72 h-72 bg-[#0B3D91]/30 rounded-full blur-3xl"></div>

      <div className="relative z-10">

        <p className="uppercase tracking-[5px] text-blue-200 text-sm font-semibold mb-5">
          Commercial Legal Advisory
        </p>

        <h3 className="text-4xl md:text-5xl font-bold leading-tight mb-8">
          Structuring Businesses <br />
          For Sustainable Growth.
        </h3>

        <div className="w-20 h-[3px] bg-white mb-8"></div>

        <p className="text-gray-300 text-lg leading-relaxed mb-6">
          Our firm delivers commercially-focused legal solutions designed
          to protect business interests, reduce operational risk, and support
          long-term expansion.
        </p>

        <p className="text-gray-400 leading-relaxed">
          Whether establishing a new business entity, drafting commercial
          agreements, or managing corporate governance obligations,
          we ensure every structure and transaction is legally sound,
          practical, and strategically aligned with your goals.
        </p>

      </div>

    </div>

    {/* RIGHT SERVICES GRID */}
    <div className="lg:col-span-7 grid md:grid-cols-2 gap-6">

      {/* CARD 1 */}
      <div className="group bg-[#F8FAFC] border border-gray-200 hover:border-[#0B3D91] rounded-[24px] p-8 transition-all duration-300 hover:shadow-xl">

        <h4 className="text-2xl font-bold text-[#0B1C39] mb-4">
          Business Registration
        </h4>

        <p className="text-gray-600 leading-relaxed">
          Registration of sole proprietorships, partnerships,
          and private limited companies through the eCitizen and e-Registry systems.
        </p>

      </div>

      {/* CARD 2 */}
      <div className="group bg-[#F8FAFC] border border-gray-200 hover:border-[#0B3D91] rounded-[24px] p-8 transition-all duration-300 hover:shadow-xl">

        <h4 className="text-2xl font-bold text-[#0B1C39] mb-4">
          Company Secretarial Services
        </h4>

        <p className="text-gray-600 leading-relaxed">
          Filing annual returns, updating CR12 records,
          preparing board resolutions, and maintaining statutory compliance.
        </p>

      </div>

      {/* CARD 3 */}
      <div className="group bg-[#F8FAFC] border border-gray-200 hover:border-[#0B3D91] rounded-[24px] p-8 transition-all duration-300 hover:shadow-xl">

        <h4 className="text-2xl font-bold text-[#0B1C39] mb-4">
          Shareholder Agreements
        </h4>

        <p className="text-gray-600 leading-relaxed">
          Structuring rights, obligations, exit clauses,
          and deadlock resolution mechanisms for shareholders and investors.
        </p>

      </div>

      {/* CARD 4 */}
      <div className="group bg-[#F8FAFC] border border-gray-200 hover:border-[#0B3D91] rounded-[24px] p-8 transition-all duration-300 hover:shadow-xl">

        <h4 className="text-2xl font-bold text-[#0B1C39] mb-4">
          Partnership Deeds
        </h4>

        <p className="text-gray-600 leading-relaxed">
          Drafting agreements covering profit sharing,
          capital contributions, management authority, and dissolution terms.
        </p>

      </div>

      {/* CARD 5 */}
      <div className="group bg-[#F8FAFC] border border-gray-200 hover:border-[#0B3D91] rounded-[24px] p-8 transition-all duration-300 hover:shadow-xl">

        <h4 className="text-2xl font-bold text-[#0B1C39] mb-4">
          Debt Collection
        </h4>

        <p className="text-gray-600 leading-relaxed">
          Demand letters, statutory notices,
          recovery negotiations, and civil claims for outstanding debts.
        </p>

      </div>

      {/* CARD 6 */}
      <div className="group bg-[#F8FAFC] border border-gray-200 hover:border-[#0B3D91] rounded-[24px] p-8 transition-all duration-300 hover:shadow-xl">

        <h4 className="text-2xl font-bold text-[#0B1C39] mb-4">
          Commercial Contracts
        </h4>

        <p className="text-gray-600 leading-relaxed">
          Drafting and reviewing supply agreements,
          NDAs, MOUs, agency agreements, and commercial transaction documents.
        </p>

      </div>

    </div>

  </div>

</section>

        </div>
      </section>

      {/* ================= NAV BUTTONS ================= */}
      <section className="py-12 px-6 bg-gray-100 border-t border-gray-200">
        <div className="max-w-7xl mx-auto flex justify-between items-center">

          {/* LEFT BUTTON */}
          <Link
            to="/services"
            className="px-6 py-3 border-2 border-[#0B3D91] text-[#0B3D91] bg-white rounded-lg font-semibold hover:bg-[#0B3D91] hover:text-white transition hover:-translate-x-1"
          >
            ← Back to practice areas
          </Link>

          {/* RIGHT BUTTON */}
          <Link
           to="/services/intellectual"
            className="px-6 py-3 bg-[#0B3D91] text-white rounded-lg font-semibold hover:bg-blue-800 transition hover:translate-x-1"
          >
            Next Area →
          </Link>

        </div>
      </section>
    </>
  );
}

export default Commercial;